var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1951 5109 c-46 -18 -84 -53 -102 -93 -18 -40 -19 -122 -19 -2456 0 -2351 1 -2416 19 -2457 12 -26 35 -52 62 -70 l43 -28 606 0 606 0 41 27 c24 16 49 44 62 70 l21 44 0 2415 c0 2350 -1 2415 -19 2456 -12 26 -35 52 -62 70 l-43 28 -595 2 c-361 1 -605 -2 -620 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3794 3650 c-47 -11 -92 -47 -114 -90 -20 -39 -20 -65 -20 -1730 0 -1663 0 -1691 20 -1729 23 -47 60 -77 109 -92 24 -7 233 -9 622 -7 l585 3 41 27 c24 16 49 44 62 70 l21 44 0 1682 c0 1391 -2 1688 -14 1715 -17 43 -76 93 -123 106 -44 13 -1139 14 -1189 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 3099 c-38 -11 -94 -64 -111 -106 -12 -27 -14 -280 -14 -1440 l0 -1407 21 -44 c13 -26 38 -54 62 -70 l41 -27 585 -3 c389 -2 598 0 622 7 49 15 86 45 109 92 20 37 20 65 20 1454 0 1370 -1 1417 -19 1453 -23 46 -46 67 -94 87 -31 13 -115 15 -614 14 -318 0 -592 -5 -608 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrends);
export default __webpack_public_path__ + "static/media/trends.3f92b767148791d09d1ac4c929c1a23a.svg";
export { ForwardRef as ReactComponent };